import { styled } from '@mui/material';
import { SimpleLinkContainerStyle } from '@components/SimpleLink/SimpleLink.types';

export const SimpleLinkContainer = styled('a')(
  ({ color }: SimpleLinkContainerStyle) => ({
    display: 'flex',

    border: `2px solid ${color}`,
    borderRadius: '6px',
    padding: '8px',

    color,
    cursor: 'pointer',
  }),
);
